<template>
<div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <router-link to="/" class="block mx-auto w-48">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
    </router-link>
    <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
      Reset your password
    </h2>
    <p class="mt-2 text-center text-sm text-gray-600 max-w">
      Think you’ve remembered your old password?
      <router-link to="/sign-in" class="font-medium text-blue-600 hover:text-blue-500">
        Sign in
      </router-link>
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <transition name="slide" mode="out-in">
        <form v-if="page === 1" key="page1" @submit.prevent="submitToken" class="space-y-6">

          <div>
            <label for="token" class="block text-sm font-medium text-gray-700">
              We've emailed you a verification code. Enter it in here to confirm you are the account owner.
            </label>
            <div class="mt-1">
              <input v-model="token" id="token" name="token" type="text" required placeholder="e.g. 987654" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            </div>
            <p v-if="$v.token.$dirty && !$v.token.required" class="mt-2 text-sm text-red-600">Please enter your verification code.</p>
          </div>

          <p v-if="invalidToken" class="text-sm text-red-600">This verification code does not appear to be valid.</p>

          <div>
              <tti-button type="submit" :loading="submitting" :disabled="submitting" class="w-full justify-center">Submit</tti-button>
          </div>

        </form>
        <form v-else-if="page === 2" key="page2" @submit.prevent="resetPassword" class="space-y-6">
          
          <div>
            <label for="newPassword" class="block text-sm font-medium text-gray-700">
              Enter your new password.
            </label>
            <div class="mt-1">
              <input v-model="newPassword" id="newPassword" name="newPassword" type="password" autocomplete="new-password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            </div>
            <p v-if="$v.newPassword.$dirty && !$v.token.required" class="mt-2 text-sm text-red-600">Please enter a password.</p>
          </div>

          <div>
              <tti-button type="submit" :loading="submitting" :disabled="submitting" class="w-full justify-center">Reset Password</tti-button>
          </div>

        </form>
      </transition>
      

    </div>
  </div>
</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'

import AuthService from '@/services/AuthServices'
const authService = new AuthService()

export default {
    components: {
        'tti-button': () => import('./TailwindButton')
    },
    props: {
        userId: { default: null }
    },
    data() {
        return {
            page: 1,
            token: null,
            newPassword: null,
            submitting: false,
            invalidToken: false
        }
    },
    validations: {
      token: {
        required
      },
      newPassword: {
        required
      }
    },
    watch: {
      token() {
        this.invalidToken = false;
      }
    },
    methods: {
        submitToken() {
          this.$v.token.$touch();
          if (this.$v.token.$invalid) return;

          this.page = 2;
        },
        async resetPassword() {
          this.submitting = true;
          this.invalidToken = false;

          this.$v.newPassword.$touch();
          if (this.$v.newPassword.$invalid) return;

          var response;
          try {
            response = await authService.resetPassword(
              this.userId, 
              this.token,
              this.newPassword);
          }
          catch {
            this.page = 1;
            this.invalidToken = true;
            return;
          }
          finally {
            this.submitting = false;
          }

          localStorage.setItem('token', response.data.token);
          this.$router.push('/my-account/?passwordreset=1');
        }
    }
}
</script>
<style scoped>

.slide-enter-active, .slide-leave-active {
  transition: .3s;
}

.slide-enter, .slide-leave-to {
    transform: translateX(-10px);
    opacity: 0;
}

</style>